import baseURL from "../common/axios";
class PackageItemMappingMAPservices {
    insert(objinsert) {
        debugger;
        return baseURL.httpMSInventoryUrl.post("PackageItemMappingMAP/Create", objinsert);
    }
    getdata() {
        debugger;
        return baseURL.httpMSInventoryUrl.get("PackageItemMappingMAP/List");
    }
    Edit(EditID) {
        debugger;
        return baseURL.httpMSInventoryUrl.get(
            "PackageItemMappingMAP/Get?packageId=" + EditID
        );
    }
    Delete(DelID) {
        debugger;
        return baseURL.httpMSInventoryUrl.delete(
            "PackageItemMappingMAP/Delete?id=" + DelID
        );
    }
    //Active
    active(DelID, Status) {
        debugger;
        return baseURL.httpMSInventoryUrl.put(
            "PackageItemMappingMAP/Active?id=" + DelID + "&Status=" + Status + ""
        );
    }
    Update(objupdate) {
        debugger;
        return baseURL.httpMSInventoryUrl.post("PackageItemMappingMAP/Update", objupdate);
    }
}
export default new PackageItemMappingMAPservices();
